import Bloc from './Bloc.js';
import Types from './Types.js';

export default class SwitchStances extends Bloc {

	constructor (src, ctx) {

		super("stance", src, ctx, true);
		this.f = (src, ins) => {
			ins[0].switchStances(ins[1], ins[2]);
			return [];
		};
		this.types = [Types.entity, Types.int, Types.bool];
	}
}